(function() {
  'use strict';

  angular
    .module('traineeWebApp.uploadedContents')
    .controller('UploadedContentsCtrl', UploadedContentsCtrl);

  UploadedContentsCtrl.$inject = ['$scope', '$timeout', 'Utils', 'FileUploadService', 'ServiceHelper', '$http', '$modal', 'mtypes'];


  function UploadedContentsCtrl($scope, $timeout, Utils, FileUploadService, ServiceHelper, $http, $modal, mtypes) {

    $scope.uploadedContentsReady = false;

    $scope.initUploadedContent = function(cModule) {
      listUploadedContent(cModule, function(outcome) {
        if (!outcome.success) return postProcess(outcome);
        cModule.uploadedContents = outcome.data.uploadedContents;
        cModule.cModuleStateStatus = outcome.data.cModuleStateStatus;
        switch (outcome.data.cModuleStateStatus) {
          case mtypes.cModuleStateStatus.started:
            cModule.status = 'started';
            cModule.progress = outcome.data.cModuleStateProgress;
            break;
          case mtypes.cModuleStateStatus.pendingTrainerReview:
            cModule.status = 'pendingTrainerReview';
            break;
        }
        $scope.uploadedContentsReady = true;
      });
    }

    $scope.hasUploadedContents = function(cModule) {
      return cModule && cModule.type === "filerequest";
    };

    function listUploadedContent(cModule, cb) {
      if (!cModule) return cb({ reason: 'null cModule' });

      var params = ServiceHelper.defaultUrlParams();
      var url = 'https://' + params.host + '/mm/cs/trainee/uploaded-content/' + cModule.courseId + '/' + cModule.id;
      $http.get(url).then(function(response) {
        cb(response.data);
      }, function(response) {
        cb({ reason: 'service call failure' });
      });
    }

    function submitUploadedContent(cModule, content, cb) {
      var params = ServiceHelper.defaultUrlParams();
      var url = 'https://' + params.host + '/mm/cs/trainee/uploaded-content-submit/' + cModule.courseId + '/' + cModule.id;
      $http.post(url, {}).then(function(response) {
        cb(response.data);
      }, function(response) {
        cb({ reason: 'service call failure' });
      });
    }

    function deleteUploadedContent(cModule, content, cb) {
      var params = ServiceHelper.defaultUrlParams();
      var url = 'https://' + params.host + '/mm/cs/trainee/uploaded-content/' + cModule.courseId + '/' + cModule.id + '/' + content.id;
      $http.delete(url).then(function(response) {
        cb(response.data);
      }, function(response) {
        cb({ reason: 'service call failure' });
      });
    }

    function saveAddedLinks(cModule, content, cb) {
      var params = ServiceHelper.defaultUrlParams();
      var url = 'https://' + params.host + '/mm/cs/trainee/added-links/' + cModule.courseId + '/' + cModule.id;
      $http.post(url, content).then(function(response) {
        var outcome = response.data;
        if (!outcome.success) return cb(outcome);
        cModule.uploadedContents.push(outcome.data);
        cb({ success: true });
      }, function(response) {
        cb({ reason: 'service call failure' });
      });
    }

    function saveUploadedContent(cModule, content, cb) {
      var params = ServiceHelper.defaultUrlParams();
      var url = 'https://' + params.host + '/mm/cs/trainee/uploaded-content/' + cModule.courseId + '/' + cModule.id;
      $http.post(url, content).then(function(response) {
        var outcome = response.data;
        if (!outcome.success) return cb(outcome);
        cModule.uploadedContents.push(outcome.data);
        cb({ success: true });
      }, function(response) {
        cb({ reason: 'service call failure' });
      });
    }

    $scope.uploadedContentClass = function(uploadedContent) {
      return 'icon-general';
    };

    function postProcess(outcome, cModule) {
      if (!outcome.success) {
        // todo: show a dialogbox complaining about the error
        console.log('postProcess', outcome);
        $scope.uploadedContentsReady = true;
      } else {
        if (cModule) $scope.initUploadedContent(cModule);
      }
    }

    $scope.uploadedContentsAction = function(action, cModule, uploadedContent) {
      if (!cModule) return;
      if (!cModule.uploadedContents) cModule.uploadedContents = [];

      switch(action) {
        case 'upload':
          var result = FileUploadService.openModal();
          if (result) result.then(function(outcome) {
            $scope.uploadedContentsReady = false;
            if (!outcome.success) return postProcess(outcome);
            if (outcome.success) {
              saveUploadedContent(cModule, {
                files: [outcome.data]
              }, function(outcome) {
                postProcess(outcome, cModule);
              });
            }
          });
          break;
        case 'submit':
          $scope.uploadedContentsReady = false;
          submitUploadedContent(cModule, uploadedContent, function(outcome) {
            postProcess(outcome, cModule);
          });
          break;
        case 'delete':
          $scope.uploadedContentsReady = false;
          deleteUploadedContent(cModule, uploadedContent, function(outcome) {
            postProcess(outcome, cModule);
          });
          break;
        case 'link':
          var result = $modal.open({
            templateUrl: 'modals/modalAddLink.html'
          });

          if (result) result.result.then(function(outcome) {
            saveAddedLinks(cModule, {
              links: [outcome.data]
            }, function(outcome) {
              postProcess(outcome, cModule);
            });
          });
          break;
      }
    };

    $scope.uploadedContentsShow = function(action, cModule) {
      switch(action) {
        case 'delete':
          var show = true;
          if (cModule && cModule.uploadedContents) {
            if (cModule.cModuleStateStatus === mtypes.cModuleStateStatus.pendingTrainerReview
              || cModule.cModuleStateStatus === mtypes.cModuleStateStatus.completed) {
              show = false;
            }
          }
          return show;
          break;
        case 'link':
        case 'upload':
          var show = true;
          if (cModule && cModule.uploadedContents) {
            if (cModule.cModuleStateStatus === mtypes.cModuleStateStatus.pendingTrainerReview
              || cModule.cModuleStateStatus === mtypes.cModuleStateStatus.completed) {
              show = false;
            }
            if (cModule.uploadedContents.length >= 10) {
              show = false;
            }
          }
          return show;
        case 'submit':
          var show = false;
          if (cModule && cModule.uploadedContents) {
            if (cModule.cModuleStateStatus === mtypes.cModuleStateStatus.started
              || cModule.cModuleStateStatus === mtypes.cModuleStateStatus.invited) {
              if (cModule.uploadedContents.length)
                show = true;
            }
          }
          return show;
      }
      return true;
    };
  }
})();

